import { OtpContainer } from 'components/auth/otp/container/OtpContainer';
import { CheckContainer } from 'components/auth/check/container/CheckContainer';
import { EmailContainer } from 'components/auth/email/container/EmailContainer';
import { LoginContainer } from 'components/auth/login/container/LoginContainer';
import { TellGateway } from 'components/auth/tellGateway/TellGateway';
import TellGatewayCheck from 'components/auth/tellGateway/TellGatewayCheck';
import { MainContainer } from 'components/auth/main/container/MainContainer';

const authRoutes = [
    { path: '', component: MainContainer, pageTitle: 'Login' },
    { path: 'login', component: LoginContainer, pageTitle: 'Login' },
    {
        path: 'open-banking',
        component: TellGatewayCheck,
        pageTitle: 'Tell Gateway Check',
    },
    { path: 'tell-gateway', component: TellGateway, pageTitle: 'Tell Gateway' },
    { path: 'email', component: EmailContainer, pageTitle: 'Login' },
    { path: 'checking/:id?', component: CheckContainer, pageTitle: 'Login' },
    { path: 'otp', component: OtpContainer, pageTitle: 'Login' },
];

export default authRoutes;
